import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Announcements from './pages/Announcements/Announcements';
import ContactUs from './pages/ContactUs/ContactUs';
import HomePage from './pages/HomePage/HomePage';
import JoinUs from './pages/JoinUs/JoinUs';
import TezzPrivacyPage from './components/Footer/TezzPrivacyPage';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/joinus" element={<JoinUs />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/tezz/privacy-policy" element={<TezzPrivacyPage />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/:sectionId?" element={<HomePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default AppRoutes;
